module.exports = __webpack_public_path__ + "img/accessory_hat_13.f35cfb82.svg";